import { Injectable } from "@angular/core";
import { SignatureApi } from "../api/signatures.api";
import { WrittenSignatureDTO } from "../model/written-signature-dto.model";

@Injectable()
export class SignatureService {

    constructor( private signatureApi: SignatureApi) { }

    getSignature = () =>
            this.signatureApi.getSignature();

    saveSignature = (sig: WrittenSignatureDTO) =>
      this.signatureApi.saveSignature(sig);

}
